import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import muiColors from 'theme/muiColors';
import muiColorsDark from 'theme/muiColorsDark';
import p from 'theme/paletteHex';
import pd from 'theme/paletteHexDark';
import { getEffectiveTheme } from 'helpers/themeHelper';
import { store } from 'store/createStore';

var muiThemeConfig = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  borderRadius: 8,
  button: {
    height: 40,
  },
  raisedButton: {
    color: p.white,
    textColor: p.defaultText,
    secondaryTextColor: p.defaultText,
    disabledColor: 'transparent',
    fontWeight: 500,
    borderRadius: 8,
  },
  flatButton: {
    fontWeight: 500,
  },
  textField: {
    borderColor: p.border,
    focusColor: p.primary,
    errorColor: p.error,
  },
  h2: {
    fontWeight: 500,
  },
};

var muiThemeConfigDark = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  borderRadius: 8,
  button: {
    height: 40,
  },
  raisedButton: {
    color: pd.bgSurface,
    textColor: pd.defaultText,
    secondaryTextColor: pd.defaultText,
    disabledColor: 'transparent',
    fontWeight: 500,
    borderRadius: 8,
  },
  flatButton: {
    fontWeight: 500,
  },
  textField: {
    borderColor: pd.border,
    focusColor: pd.primary,
    errorColor: pd.error,
  },
  h2: {
    fontWeight: 500,
  },
};

var lightTheme = getMuiTheme(Object.assign({}, muiThemeConfig, { palette: muiColors }));
var darkTheme = getMuiTheme(Object.assign({}, muiThemeConfigDark, { palette: muiColorsDark }));

class ThemeProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      themeMode: store.getState().app.themeMode || 'system',
    };
  }

  componentDidMount() {
    var self = this;
    this._unsubscribe = store.subscribe(function() {
      var themeMode = store.getState().app.themeMode || 'system';
      if (themeMode !== self.state.themeMode) {
        self.setState({ themeMode: themeMode });
      }
    });
  }

  componentWillUnmount() {
    if (this._unsubscribe) {
      this._unsubscribe();
    }
  }

  render() {
    var effective = getEffectiveTheme(this.state.themeMode);
    var muiTheme = effective === 'dark' ? darkTheme : lightTheme;

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        {this.props.children}
      </MuiThemeProvider>
    );
  }
}

export default ThemeProvider;
